<template>
  <div>
    <router-tab
      class="routerTab"
      :tabs="tabs"
      :max-alive="10"
      language="en"
      page-transition="page-fade"
      :keep-alive="true"
    />

    <v-tooltip bottom nudge-right="50" color="primary" style="z-index: 81">
      <template v-slot:activator="{ on }">
        <font-awesome-icon
          v-on="on"
          class="clearAll"
          icon="times-circle"
          style="z-index: 80; position: absolute; left: 3px"
          @click="clear"
          :style="{ color: 'red' }"
        />
      </template>
      <span>Clear All Tabs</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: ["/"],
    };
  },
  methods: {
    clear() {
      var current = this.$route.fullPath;
      // this.$tabs.reset(current);
    },
  },
};
</script>

<style>
.routerTab {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  overflow: auto !important;
  z-index: 50;
}

.router-tab__scrollbar {
  height: 8px !important;
}

.router-alive {
  background-color: #7169cf07;
  /* background-color: red; */
  overflow: scroll;
}

/* .router-tab__scrollbar:hover { */
/* height: 7px !important; */
/* overflow-x: hidden !important; */
/* opacity: 1 !important; */
/* } */

.router-tab__header {
  overflow-y: hidden !important;
  overflow-x: auto !important;
  background-color: white;
}

.clearAll {
  position: absolute;
  top: 15px;
  left: 3px;
}

.router-tab__scrollbar-thumb:hover,
.router-tab__scrollbar.is-dragging .router-tab__scrollbar-thumb {
  background-color: var(--v-primary-base);
}
</style>

<style lang="scss">
// Page fade transition
.page-fade {
  //   &-enter-active,
  //   &-leave-active {
  //     transition: opacity 0.3s ease;
  //   }
  //   &-enter, &-leave-to
  // /* .component-fade-leave-active below version 2.1.8 */ {
  //     opacity: 0;
  //   }

  &-enter,
  &-leave {
    transition-property: opacity;
    transition-duration: 1s;
  }

  &-enter,
  &-leave-to {
    opacity: 1;
  }

  &-enter,
  &-enter-active {
    opacity: 1;
  }

  // &-leave-active,
  // &-enter {
  //   opacity: 2s;
  // }

  // &-enter-active,
  // &-leave-active {
  //   transition: all 0.5s;
  // }

  // &-enter,
  // &-leave-to {
  //   opacity: 0s;
  // }

  &-enter,
  &-enter-active {
    opacity: 0;
  }

  &-enter {
    transform: translateX(-30px);
  }

  &-leave-to {
    transform: translateX(30px);
  }
}

.tab-scale {
  &-enter-active,
  &-leave-active {
    transition-property: opacity;
    transition-duration: 0.2s;
  }

  &-enter,
  &-enter-to {
    opacity: 0;
  }

  &-leave,
  &-leave-to {
    opacity: 0;
    transform: scale(10);
  }
}
</style>
